import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Carousel,
  Badge,
  Spinner
} from "react-bootstrap";
import {
  StarFill,
  Heart,
  HeartFill,
  Truck
} from "react-bootstrap-icons";
import { useParams, useNavigate } from "react-router-dom";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { toast } from "react-toastify";
import { CartContext } from "../context/CartContext";
import { WishlistContext } from "../context/WishlistContext";
import api from "../admin/api/api";
import "./ProductDetails.scss";
import RelatedProducts from "../Components/RelatedProducts";
import { image_base_url } from "../admin/api/api";

function ProductDetails() {

  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useContext(CartContext);
  const { addToWishlist } = useContext(WishlistContext);

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [quantity, setQuantity] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [wishlist, setWishlist] = useState(false);
  //const BASE_URL = "http://localhost:5170/";

  // ✅ FETCH PRODUCT
  useEffect(() => {

    const fetchProduct = async () => {
      try {
        setLoading(true);

        const res = await api.get(`/public/products/${id}`);

        const data = res.data;
        setProduct(data);

        // Set default variant
        if (data.variants?.length > 0) {
          setSelectedVariant(data.variants[0]);
        }

      } catch (err) {
        console.error(err);
        setError("Failed to load product.");
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();

  }, [id]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Loading product...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="text-center mt-5">
        <h4>{error}</h4>
      </Container>
    );
  }

  if (!product) {
    return (
      <Container className="text-center mt-5">
        <h4>Product Not Found</h4>
      </Container>
    );
  }

  // ✅ Quantity Controls
  const increment = () => {
    if (selectedVariant && quantity < selectedVariant.stockQuantity) {
      setQuantity(quantity + 1);
    } else {
      toast.error("Stock limit reached!");
    }
  };

  const decrement = () => {
    if (quantity > 1) setQuantity(quantity - 1);
  };

  // ✅ Add To Cart
  const handleAddToCart = () => {

  if (!selectedVariant) {
    toast.error("Please select size & color");
    return;
  }

  const cartItem = {
    id: product.productId,
    name: product.productName,
    price: product.price,
    mrp: product.mrp,
    image: image_base_url + product.mainImage,
    quantity: quantity,
    variantId: selectedVariant.variantId,
    size: selectedVariant.size,
    color: selectedVariant.color
  };

  addToCart(cartItem);

  toast.success("Product added to cart 🛒");
};

  const handleBuyNow = () => {
    handleAddToCart();
    navigate("/cart");
  };

   const popoverReturn = (
  <Popover id="popover-basic">
    <Popover.Header as="h3">Return & Exchange</Popover.Header>
    <Popover.Body>
      Any other reason <strong>10 days</strong> from delivery on Exchange with a different Package or Items.
      right?
    </Popover.Body>
  </Popover>
);

   const popoverPay = (
  <Popover id="popover-basic">
    <Popover.Header as="h3">Pay on Delivery (Cash/Card)</Popover.Header>
    <Popover.Body>
      Pay on Delivery (Cash/Card) payment method includes <strong>Cash on Delivery (COD) </strong> as well as Debit card / Credit card / Net banking payments at your doorstep.
    </Popover.Body>
  </Popover>
);

    const popoverSecure = (
  <Popover id="popover-basic">
    <Popover.Header as="h3">Your transaction is secure</Popover.Header>
    <Popover.Body>
      Our payment security system encrypts your information during transmission. We don’t share your credit card details with third-party sellers.
      right?
    </Popover.Body>
  </Popover>
);

  return (
    <>
    <Container className="product-details mt-4 pb-5">
      <Row className="mt-3 pb-3">

        {/* ================= IMAGE SECTION ================= */}
        <Col md={5} style={{paddingTop : "25px"}}>
          <Carousel style={{border : "1px solid lightgray", borderRadius :"10px"}}>
            {(product.images?.length > 0
              ? product.images
              : [{ imageUrl: product.mainImage }]
            ).map((img, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={`${image_base_url}${img.imageUrl}`}
                  alt={product.productName}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </Col>

        {/* ================= DETAILS SECTION ================= */}
        <Col md={7} style={{paddingTop : "25px"}}>

          <h4 className="mb-2">{product.productName}</h4>

          {/* Rating */}
          <div className="rating mb-2">
            <StarFill className="text-warning" />
            <StarFill className="text-warning" />
            <StarFill className="text-warning" />
            <StarFill className="text-warning" />
            <StarFill className="text-muted" />
            <span className="ms-2">(124 Reviews)</span>
          </div>

          {/* Price */}
          <div className="price-section02 mb-3">
            <h5 className="d-inline">₹{product.price}</h5>

            {product.mrp && (
              <span className="text-muted text-decoration-line-through ms-2">
                ₹{product.mrp}
              </span>
            )}

            {product.discountPercent > 0 && (
              <Badge bg="success" className="ms-2">
                {product.discountPercent}% OFF
              </Badge>
            )}
          </div>

          {/* Stock */}
          {selectedVariant && (
            <p className="text-danger fw-bold">
              {selectedVariant.stockQuantity > 0
                ? `In Stock: ${selectedVariant.stockQuantity}`
                : "Out of Stock"}
            </p>
          )}

          {/* Description */}
          <p>{product.description}</p>



          {/* terms */}
          <div className="mb-4" style={{paddingTop :"10px", paddingBottom :"10px", borderBottom :"1px solid lightgray", borderTop :"1px solid lightgray"}}>

            <Container>
             <Row>
              <Col>
                
                <OverlayTrigger trigger="click" placement="bottom" overlay={popoverReturn}>
                  <Button variant="outline-warning w-100" style={{fontSize : "small"}}>Return & Exchange</Button>
                </OverlayTrigger>

              </Col>

              <Col>
                
                <OverlayTrigger trigger="click" placement="bottom" overlay={popoverPay}>
                  <Button variant="outline-warning w-100" style={{fontSize : "small"}}>Pay on Delivery</Button>
                </OverlayTrigger>

              </Col>

              <Col>
                
                <OverlayTrigger trigger="click" placement="bottom" overlay={popoverSecure}>
                  <Button variant="outline-warning w-100" style={{fontSize : "small"}}>Secure Transaction</Button>
                </OverlayTrigger>

              </Col>
             </Row>
            </Container>

          </div>

          {/* Variant Selection */}
          {product.variants?.length > 0 && (
            <div className="mb-4">
              <h6>Select Size / Color</h6>
              <div className="d-flex flex-wrap gap-2">
                {product.variants.map((variant) => (
                  <Button
                    key={variant.variantId}
                    size="sm"
                    variant={
                      selectedVariant?.variantId === variant.variantId
                        ? "dark"
                        : "outline-secondary"
                    }
                    onClick={() => {
                      setSelectedVariant(variant);
                      setQuantity(1);
                    }}
                  >
                    {variant.size} - {variant.color}
                  </Button>
                ))}
              </div>
            </div>
          )}

          {/* Quantity */}
          <div className="mb-4">
            <h6>Quantity</h6>
            <div className="d-flex align-items-center gap-2">
              <Button variant="outline-danger" onClick={decrement}>
                −
              </Button>
              <span>{quantity}</span>
              <Button variant="outline-success" onClick={increment}>
                +
              </Button>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex gap-2 flex-wrap mt-3">
            <Button variant="dark" onClick={handleAddToCart} >
            Add To Cart
          </Button>

            <Button variant="success" onClick={handleBuyNow}>
              Buy Now
            </Button>

            <Button
              variant="outline-danger" style={{border : "2px solid"}}
              onClick={() => {
                addToWishlist(product.productId);
                setWishlist(!wishlist);
                toast.success("Added to Wishlist ❤️");
              }}
            >
              {wishlist ? <HeartFill /> : <Heart />} Wishlist
            </Button>
          </div>

          <div className="mt-4">
            <Truck /> Free Delivery in 3-5 days
          </div>

        </Col>
      </Row>
    </Container>

    <Container className="product-details"></Container>

    {product?.subCategoryId && (
     <RelatedProducts subCategoryId={product.subCategoryId} />
    )}

    <Container className="product-details mt-4 pb-5"></Container>


   </>
  );
}

export default ProductDetails;